import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import CampaignDashboard from './components/CampaignDashboard';
import CampaignDetails from './components/CampaignDetails';
import OrderManagement from './components/OrderManagement';
import { ErrorBoundary, AsyncErrorBoundary, AdminApiErrorBoundary } from './components/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <AsyncErrorBoundary>
        <AdminApiErrorBoundary>
          <Layout>
            <Routes>
              <Route path="/" element={<Navigate to="/campaigns" replace />} />
              <Route path="/campaigns" element={<CampaignDashboard />} />
              <Route path="/campaigns/:campaignId" element={<CampaignDetails />} />
              <Route path="/orders" element={<OrderManagement />} />
            </Routes>
          </Layout>
        </AdminApiErrorBoundary>
      </AsyncErrorBoundary>
    </ErrorBoundary>
  );
}

export default App;